module.exports = __webpack_public_path__ + "img/ad-bg.92997696.png";